module.exports = __webpack_public_path__ + "img/maison-7.340c2181.png";